import React from "react";
import { Form, FormGroup, Button } from "reactstrap";
import PhoneInputWithCountrySelect from "react-phone-number-input";

const RegistrationForm = ({ phoneNumber, setPhoneNumber, firstName, setFirstName, lastName, setLastName, onSubmit }) => {
  const isMobile = window.innerWidth < 768;

  return (
    <>
      <h1
        className="mfa-title"
        style={{ fontSize: isMobile ? "24px" : "28px" }}
      >
        Enter your contact information
      </h1>
      <p
        className="mfa-subtitle"
        style={{ fontSize: isMobile ? "14px" : "16px" }}
      >
        Your company requires your contact information for employee
        registration.
      </p>

      <Form onSubmit={onSubmit} noValidate>
        <FormGroup>
          <input
            type="text"
            className="form-control"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            style={{
              width: "100%",
              height: isMobile ? "60px" : "50px",
              fontSize: isMobile ? "16px" : "16px",
            }}
          />
        </FormGroup>
        <FormGroup>
          <input
            type="text"
            className="form-control"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            style={{
              width: "100%",
              height: isMobile ? "60px" : "50px",
              fontSize: isMobile ? "16px" : "16px",
            }}
          />
        </FormGroup>
        <FormGroup>
          <div className="phone-input-row">
            <PhoneInputWithCountrySelect
              placeholder="Enter Mobile number"
              value={phoneNumber}
              onChange={setPhoneNumber}
              className="form-control p-0"
              defaultCountry="US"
              style={{
                width: "100%",
                height: isMobile ? "60px" : "50px",
                fontSize: isMobile ? "16px" : "16px",
              }}
            />
          </div>
        </FormGroup>

        <Button
          type="submit"
          color="dark"
          className="continue-btn"
          block
          style={{ height: isMobile ? "45px" : "50px" }}
        >
          Submit
        </Button>
      </Form>
    </>
  );
};

export default RegistrationForm;
